/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
import * as i0 from "./settings-body.component.scss.shim.ngstyle";
import * as i1 from "@angular/core";
import * as i2 from "./settings-body.component";
var styles_SettingsBodyComponent = [i0.styles];
var RenderType_SettingsBodyComponent = i1.ɵcrt({ encapsulation: 0, styles: styles_SettingsBodyComponent, data: {} });
export { RenderType_SettingsBodyComponent as RenderType_SettingsBodyComponent };
export function View_SettingsBodyComponent_0(_l) { return i1.ɵvid(0, [i1.ɵncd(null, 0)], null, null); }
export function View_SettingsBodyComponent_Host_0(_l) { return i1.ɵvid(0, [(_l()(), i1.ɵeld(0, 0, null, null, 1, "cc-settings-body", [], null, null, null, View_SettingsBodyComponent_0, RenderType_SettingsBodyComponent)), i1.ɵdid(1, 114688, null, 0, i2.SettingsBodyComponent, [], null, null)], function (_ck, _v) { _ck(_v, 1, 0); }, null); }
var SettingsBodyComponentNgFactory = i1.ɵccf("cc-settings-body", i2.SettingsBodyComponent, View_SettingsBodyComponent_Host_0, {}, {}, ["*"]);
export { SettingsBodyComponentNgFactory as SettingsBodyComponentNgFactory };
